
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router"
import { LoginComponent } from "./auth/login/login.component"
import { SignUpComponent } from './auth/signUp/signUp.component';
import { DashboardComponent } from "./dashboard/home/dashboard.component";
import { UserDetailComponent } from "./dashboard/user-detail/user-detail.component";
import { UsersComponent } from "./dashboard/users/users.component";
import { MapsComponent } from "./dashboard/maps/maps.component";
import { AuthGuard } from './auth/auth.guard'
import { from } from 'rxjs';
import { VerifyAccountComponent } from './auth/verify-account/verify-account.component';
import { HubTransferComponent } from './dashboard/hub-transfer/hub-transfer.component';
import { HubReplacementComponent } from './dashboard/hub-replacement/hub-replacement.component';
import { HubTransferV2Component } from "./dashboard/hub-transferv2/hub-transferv2.component";
import { RatingComponent } from "./dashboard/rating/rating.component";
import { UtilsComponent } from "./dashboard/utils/utils.component";
import { ActivitylogComponent } from "./activitylog/activitylog.component";


const routes: Routes = [
  // {path: '', component: LoginComponent },
  { path: '', redirectTo: '/home', pathMatch: 'full', canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  // { path: 'signup', component: SignUpComponent },
  { path: 'home', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'user/:id', component: UserDetailComponent, canActivate: [AuthGuard] },
  { path: 'hubTransfer/:hubId', component: HubTransferComponent, canActivate: [AuthGuard] },
  { path: 'hubTransferV2/:hubIds', component: HubTransferV2Component, canActivate: [AuthGuard] },
  { path: 'hubReplacement/:custId', component: HubReplacementComponent, canActivate: [AuthGuard] },
  { path: 'ratings', component: RatingComponent, canActivate: [AuthGuard] },
  { path: 'verifyAccount/:id', component: VerifyAccountComponent },
  { path: 'changePassword/:id', component: VerifyAccountComponent },
  {
    path: 'users', component: UsersComponent, canActivate: [AuthGuard], runGuardsAndResolvers: 'always'
  },
  { path: 'maps', component: MapsComponent, canActivate: [AuthGuard] },
  {path:'activitylogs',component:ActivitylogComponent,canActivate:[AuthGuard]},
  { path: 'utils', component: UtilsComponent, canActivate: [AuthGuard] },
  { path: '**', redirectTo: '/home', pathMatch: 'full', canActivate: [AuthGuard] },
  { path: '**', redirectTo: '/login', pathMatch: 'full'},
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule {

}
